<div class="d-flex flex-column align-items-center my-5 text-center">
  <h1>Utilisateur non autorisé</h1>
  <p>Votre utilisateur n'est pas autorisé à accéder à cette application. Contactez votre administrateur.</p>
  <button class="btn btn-primary" (click)="logout()">Changer de compte</button>
</div>

